'use client'

import { useEffect, useRef } from 'react'
import type { Socket } from 'socket.io-client'

export default function useSocketEvent<
  S extends Socket<any, any>,
  E extends S extends Socket<infer E, any> ? E : never,
  K extends keyof E & (string | symbol),
>(socket: S, eventName: K, handler: E[K]) {
  const savedHandler = useRef(handler)

  useEffect(() => {
    savedHandler.current = handler
  }, [handler])

  useEffect(() => {
    const listener: typeof handler = (...args: any[]) => {
      savedHandler.current(...args)
    }

    socket.on(eventName, listener)

    return () => {
      socket.off(eventName, listener)
    }
  }, [eventName, socket])
}
